import React, { useState } from 'react';
import { Document, Page } from '@react-pdf/renderer';
// import 'react-pdf/dist/esm/Page/AnnotationLayer.css';

const MonitoringContract = () => {
    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);
    const [signature, setSignature] = useState('');
    const [submitted, setSubmitted] = useState(false);

    const onDocumentLoadSuccess = ({ numPages }) => {
        setNumPages(numPages);
    };

    const handlePreviousPage = () => {
        if (pageNumber > 1) setPageNumber(pageNumber - 1);
    };

    const handleNextPage = () => {
        if (pageNumber < numPages) setPageNumber(pageNumber + 1);
    };

    const handleSignatureChange = (e) => {
        setSignature(e.target.value);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (signature.trim()) {
            setSubmitted(true);
            alert('Contract signed and submitted successfully!');
        } else {
            alert('Please add your signature before submitting.');
        }
    };

    return (
        <div style={{ padding: '20px' }}>
            <h1>Monitoring Contract</h1>
            <div style={{ border: '1px solid #ccc', padding: '10px', marginBottom: '20px' }}>
                <Document
                    file="/path/to/your/contract.pdf"
                    onLoadSuccess={onDocumentLoadSuccess}
                >
                    <Page pageNumber={pageNumber} />
                </Document>
                <div style={{ marginTop: '10px', textAlign: 'center' }}>
                    <button onClick={handlePreviousPage} disabled={pageNumber <= 1}>
                        Previous
                    </button>
                    <span style={{ margin: '0 10px' }}>
                        Page {pageNumber} of {numPages}
                    </span>
                    <button onClick={handleNextPage} disabled={pageNumber >= numPages}>
                        Next
                    </button>
                </div>
            </div>
            {!submitted ? (
                <form onSubmit={handleSubmit}>
                    <label>
                        Signature:
                        <input
                            type="text"
                            value={signature}
                            onChange={handleSignatureChange}
                            placeholder="Type your signature here"
                            style={{ marginLeft: '10px', padding: '5px', width: '300px' }}
                        />
                    </label>
                    <button type="submit" style={{ marginLeft: '10px', padding: '5px 10px' }}>
                        Sign & Submit
                    </button>
                </form>
            ) : (
                <p style={{ color: 'green' }}>Thank you! The contract has been signed and submitted.</p>
            )}
        </div>
    );
};

export default MonitoringContract;